/*
 * Author: Dw
 * File Created: Friday, 24-07-12 03:43 pm
 * Last Modified: Tuesday, 24-11-19 02:39 pm, by Roger
 */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function ArrowDropDown(props: SvgIconProps) {
  return <SvgIcon inheritViewBox {...props} data-sentry-element="SvgIcon" data-sentry-component="ArrowDropDown" data-sentry-source-file="index.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-source-file="index.tsx">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.3637 8.36358C5.71517 8.01211 6.28502 8.01211 6.63649 8.36358L12.0001 13.7272L17.3637 8.36358C17.7152 8.01211 18.285 8.01211 18.6365 8.36358C18.988 8.71505 18.988 9.2849 18.6365 9.63637L12.6365 15.6364C12.285 15.9878 11.7152 15.9878 11.3637 15.6364L5.3637 9.63637C5.01223 9.2849 5.01223 8.71505 5.3637 8.36358Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      </svg>
    </SvgIcon>;
}
export default ArrowDropDown;